import React from 'react';

export enum ServiceType {
  MOVING = 'moving',
  FULL_SERVICE = 'full_service',
  SELF_STORAGE = 'self_storage',
}

interface ZipCodeStatusProps {
  serviceAreaClassifier?: any;
  serviceType: ServiceType;
  isChannelPartnerLead?: boolean;
}

const STATUSES = {
  INVALID_ZIP: 'Invalid zip code',
  OUT_OF_SERVICE_AREA: 'Out of service area',
};

const AVAILABILITY = {
  AVAILABLE: 'Available',
  UNAVAILABLE: 'Unavailable',
};

export const ZipCodeStatus: React.FC<ZipCodeStatusProps> = ({
  serviceAreaClassifier,
  serviceType,
  isChannelPartnerLead,
}) => {
  if (!serviceAreaClassifier) {
    return null;
  }

  const getMessage = () => {
    if (!serviceAreaClassifier.valid) {
      return STATUSES.INVALID_ZIP;
    }

    switch (serviceType) {
      case ServiceType.MOVING:
        return serviceAreaClassifier.moving_eligible
          ? `Moving ${AVAILABILITY.AVAILABLE}`
          : `Moving ${AVAILABILITY.UNAVAILABLE}`;

      case ServiceType.FULL_SERVICE:
        return serviceAreaClassifier.full_service_eligible
          ? `Full-Service ${AVAILABILITY.AVAILABLE}`
          : `Full-Service ${AVAILABILITY.UNAVAILABLE}`;

      case ServiceType.SELF_STORAGE:
        // For channel partners, self storage is always available
        if (isChannelPartnerLead) {
          return `Self-Storage ${AVAILABILITY.AVAILABLE}`;
        }

        return serviceAreaClassifier.self_storage_eligible
          ? `Self-Storage ${AVAILABILITY.AVAILABLE}`
          : `Self-Storage ${AVAILABILITY.UNAVAILABLE}`;

      default:
        return STATUSES.OUT_OF_SERVICE_AREA;
    }
  };

  const getClassName = (message: string) => {
    if (message.includes(AVAILABILITY.UNAVAILABLE)) {
      return 'text-danger';
    }
    if (message.includes(AVAILABILITY.AVAILABLE)) {
      return 'text-success';
    }

    switch (message) {
      case STATUSES.INVALID_ZIP:
      case STATUSES.OUT_OF_SERVICE_AREA:
        return 'text-danger';
      default:
        return '';
    }
  };

  const message = getMessage();
  const messageClass = getClassName(message);

  if (!message) {
    return null;
  }

  return (
    <strong>
      <p className={messageClass}>{message}</p>
    </strong>
  );
};
